/**
 * Compatibility entrypoint (BKPE-27796).
 *
 * Analytics implementation is owned by `features/analytics`. Re-exporting
 * the canonical module preserves its event queue and other singleton state
 * for legacy consumers until the follow-up import cleanup removes this path.
 */
export * from 'features/analytics';
